import React from "react";
import { Layout as AntLayout } from "antd";
import { LayoutProps as AntLayoutProps } from "antd/lib/layout";

export const Header = (props: AntLayoutProps) => {
  const { children, ...rest } = props;
  return <AntLayout.Header {...rest}>{children}</AntLayout.Header>;
};
